module.exports = __webpack_public_path__ + "static/media/tip-1.6325b813.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/tip-1.png
// module id = 537
// module chunks = 0